import React from 'react';
import { LazySection } from './LazySection';
export function Mecanismo() {
  return <LazySection className="bg-ink text-cream !py-[80px] md:!py-[100px]" data-id="element-197">
      <div className="container-wide" data-id="element-198">
        <div className="text-center" data-id="element-199">
          <span className="eyebrow !text-gold-light" data-id="element-200">
            El origen de tus bloqueos
          </span>
        </div>
        <h2 className="text-[clamp(34px,5vw,54px)] mb-6 text-center text-cream" data-id="element-201">
          Mucho de lo que sentís{' '}
          <em className="text-gold-light" data-id="element-202">ni siquiera empezó con vos</em>.
        </h2>
        <p className="text-center text-lg text-cream/80 max-w-[720px] mx-auto mb-[60px]" data-id="element-203">
          Así como heredaste el color de tus ojos, heredaste los programas
          emocionales de tu familia. Y esos programas no aparecen como recuerdos
          — aparecen como{' '}
          <span className="highlight-keyword-light" data-id="element-204">patrones</span> que no podés
          explicar.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-[30px] relative mb-[60px]" data-id="element-205">
          {/* Line connector for desktop */}
          <div className="hidden md:block absolute top-[30px] left-[8%] right-[8%] h-[1px] bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-206" />

          <div className="text-center relative" data-id="element-207">
            <div className="w-3.5 h-3.5 bg-gold-light border-[3px] border-ink rounded-full mx-auto mb-5 shadow-[0_0_0_4px_rgba(230,184,120,0.2)] relative z-10" data-id="element-208" />
            <div className="font-serif text-[13px] text-gold-light mb-1.5 font-medium" data-id="element-209">
              Hace 3 generaciones
            </div>
            <div className="font-serif text-[19px] mb-2 text-cream" data-id="element-210">
              Bisabuelos
            </div>
            <p className="text-[13px] text-cream/70 leading-relaxed" data-id="element-211">
              Vivieron traumas que no pudieron procesar.
            </p>
          </div>

          <div className="text-center relative" data-id="element-212">
            <div className="w-3.5 h-3.5 bg-gold-light border-[3px] border-ink rounded-full mx-auto mb-5 shadow-[0_0_0_4px_rgba(230,184,120,0.2)] relative z-10" data-id="element-213" />
            <div className="font-serif text-[13px] text-gold-light mb-1.5 font-medium" data-id="element-214">
              Hace 2 generaciones
            </div>
            <div className="font-serif text-[19px] mb-2 text-cream" data-id="element-215">
              Abuelos
            </div>
            <p className="text-[13px] text-cream/70 leading-relaxed" data-id="element-216">
              Los callaron. Los enterraron en silencio.
            </p>
          </div>

          <div className="text-center relative" data-id="element-217">
            <div className="w-3.5 h-3.5 bg-gold-light border-[3px] border-ink rounded-full mx-auto mb-5 shadow-[0_0_0_4px_rgba(230,184,120,0.2)] relative z-10" data-id="element-218" />
            <div className="font-serif text-[13px] text-gold-light mb-1.5 font-medium" data-id="element-219">
              Hace 1 generación
            </div>
            <div className="font-serif text-[19px] mb-2 text-cream" data-id="element-220">Padres</div>
            <p className="text-[13px] text-cream/70 leading-relaxed" data-id="element-221">
              Los cargaron sin saberlo, y te los transmitieron.
            </p>
          </div>

          <div className="text-center relative" data-id="element-222">
            <div className="w-3.5 h-3.5 bg-gold-light border-[3px] border-ink rounded-full mx-auto mb-5 shadow-[0_0_0_4px_rgba(230,184,120,0.2)] relative z-10" data-id="element-223" />
            <div className="font-serif text-[13px] text-gold-light mb-1.5 font-medium" data-id="element-224">
              Hoy
            </div>
            <div className="font-serif text-[19px] mb-2 text-cream" data-id="element-225">Vos</div>
            <p className="text-[13px] text-cream/70 leading-relaxed" data-id="element-226">
              Los estás sintiendo — sin entender por qué.
            </p>
          </div>
        </div>

        <div className="bg-gold/10 border border-gold/25 rounded-[20px] p-8 md:px-10 md:py-11 text-center max-w-[780px] mx-auto mb-[60px]" data-id="element-227">
          <h3 className="text-[clamp(24px,3.5vw,32px)] mb-[18px] leading-[1.25] text-cream" data-id="element-228">
            Eso que llamás autosabotaje tiene un nombre:{' '}
            <span className="bg-gradient-to-br from-gold/25 to-gold/25 px-2 py-0.5 rounded italic text-[#f5d9a8]" data-id="element-229">
              <span className="highlight-keyword-light" data-id="element-230">lealtad</span> familiar
              inconsciente
            </span>
            .
          </h3>
          <p className="text-cream/85 text-base max-w-[620px] mx-auto" data-id="element-231">
            Tu sistema nervioso aprendió de tu familia qué emociones eran
            "seguras", qué nivel de felicidad era "permitido", qué tipo de
            relaciones eran "normales". Y los repite en automático — aunque tu
            mente adulta quiera otra cosa.
          </p>
        </div>

        <div className="max-w-[900px] mx-auto" data-id="element-232">
          <h3 className="text-center text-[clamp(22px,3vw,28px)] mb-[30px] text-gold-light" data-id="element-233">
            No es espiritualidad.{' '}
            <em className="text-cream not-italic" data-id="element-234">Es ciencia publicada.</em>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-235">
            <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-236">
              <div className="font-serif text-gold-light text-xs tracking-[0.05em] mb-2.5 font-medium" data-id="element-237">
                Universidad de Emory · 2013
              </div>
              <h4 className="text-cream text-base mb-2.5 font-medium" data-id="element-238">
                Los miedos se heredan entre generaciones
              </h4>
              <p className="text-[13px] text-cream/70 leading-[1.55]" data-id="element-239">
                Brian Dias demostró que los miedos aprendidos por una generación
                se transmiten epigenéticamente a la siguiente — sin que la nueva
                generación los haya vivido.
              </p>
            </div>

            <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-240">
              <div className="font-serif text-gold-light text-xs tracking-[0.05em] mb-2.5 font-medium" data-id="element-241">
                Mount Sinai Hospital · 2015
              </div>
              <h4 className="text-cream text-base mb-2.5 font-medium" data-id="element-242">
                El trauma deja marcas biológicas heredables
              </h4>
              <p className="text-[13px] text-cream/70 leading-[1.55]" data-id="element-243">
                Rachel Yehuda documentó alteraciones epigenéticas en hijos de
                sobrevivientes del Holocausto — publicado en{' '}
                <em className="text-gold-light" data-id="element-244">Biological Psychiatry</em>.
              </p>
            </div>

            <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-245">
              <div className="font-serif text-gold-light text-xs tracking-[0.05em] mb-2.5 font-medium" data-id="element-246">
                Psicología transgeneracional
              </div>
              <h4 className="text-cream text-base mb-2.5 font-medium" data-id="element-247">
                El origen familiar se puede mapear
              </h4>
              <p className="text-[13px] text-cream/70 leading-[1.55]" data-id="element-248">
                Schützenberger, Hellinger y Lipton: trazar el{' '}
                <span className="highlight-keyword-light" data-id="element-249">origen</span> familiar
                de un patrón es el primer paso real para interrumpirlo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </LazySection>;
}